import styled, { css, keyframes } from 'styled-components';

import { TabPanel as MuiTabPanel } from '@mui/lab';
import { Tab as MuiTab } from '@mui/material';

type CustomTabProps = {
  mustUpdate?: boolean;
};

export const Wrapper = styled.aside`
  ${({ theme }) => css`
    min-width: 450px;
    max-width: 450px;
    height: 100%;

    border-left: 1px solid ${theme.yoga.colors.moduleBorder};

    overflow-y: scroll;
    background-color: ${theme.palette.background.default};

    @media screen and (max-width: 1024px) {
      min-width: 100vw;
      max-width: 100vw;
    }
  `}
`;

export const Header = styled.header`
  ${({ theme }) => css`
    box-shadow: ${theme.yoga.elevations.medium};
    position: sticky;
    top: 0;
    background-color: ${theme.yoga.colors.white};

    z-index: 5;
  `}
`;

const ping = keyframes`
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
`;

export const Tab = styled(MuiTab)<CustomTabProps>`
  ${({ theme, mustUpdate }) => css`
    text-transform: none;
    position: relative;

    ${mustUpdate &&
    css`
      &::before {
        position: absolute;
        content: '';
        top: 12px;
        right: 10px;
        width: 8px;
        height: 8px;
        background-color: ${theme.palette.error.main};

        border-radius: ${theme.yoga.radii.circle}px;
      }

      &::after {
        position: absolute;
        content: '';
        top: 12px;
        right: 10px;
        width: 8px;
        height: 8px;
        background-color: ${theme.palette.error.main};

        animation: ${ping} 1s cubic-bezier(0, 0, 0.2, 1) infinite;
        border-radius: ${theme.yoga.radii.circle}px;
      }
    `}
  `}
`;

export const TabPanel = styled(MuiTabPanel)`
  ${({ theme }) => css`
    padding: ${theme.yoga.spacing.zero}px;
    background-color: ${theme.yoga.colors.backgroundLight};
    min-height: calc(100% - 156px);
    position: relative;
  `}
`;

export const Footer = styled.footer`
  ${({ theme }) => css`
    position: sticky;
    bottom: 0;
    background-color: ${theme.yoga.colors.white};

    z-index: 5;
  `}
`;
